import React from "react";
import { TextField, Box, TextFieldProps } from "@mui/material";
import { FieldProps, getIn } from "formik";

export const AppTextField: React.FC<FieldProps & TextFieldProps> = (props) => {
  const isTouched = getIn(props.form.touched, props.field.name);
  const errorMessage = getIn(props.form.errors, props.field.name);

  const { error, helperText, field, form, sx, ...rest } = props;

  return (
    <Box mt={2}>
      <TextField
        fullWidth
        variant="outlined"
        error={error ?? Boolean(isTouched && errorMessage)}
        helperText={
          helperText ?? (isTouched && errorMessage ? errorMessage : undefined)
        }
        {...rest}
        {...field}
        sx={sx} // ✅ propagate styles!
      />
    </Box>
  );
};
